import React from 'react';
import { Card } from './Card';
import { twMerge } from 'tailwind-merge';
interface StatCardProps {
  title: string;
  value: string | React.ReactNode;
  icon?: React.ReactNode;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}
export function StatCard({
  title,
  value,
  icon,
  trend,
  className
}: StatCardProps) {
  return <Card className={twMerge('flex flex-col justify-between', className)} data-id="element-61">
      <div className="flex justify-between items-start mb-2" data-id="element-62">
        <h3 className="text-sm font-medium text-text-secondary" data-id="element-63">{title}</h3>
        {icon && <div className="text-brand-primary bg-brand-primary/10 p-2 rounded-lg" data-id="element-64">
            {icon}
          </div>}
      </div>
      <div data-id="element-65">
        <div className="text-2xl font-bold text-text-primary" data-id="element-66">{value}</div>
        {trend && <div className={twMerge('text-xs font-medium mt-1 flex items-center', trend.isPositive ? 'text-brand-success' : 'text-brand-danger')} data-id="element-67">
            {trend.isPositive ? '↑' : '↓'} {trend.value}
          </div>}
      </div>
    </Card>;
}